export function scrollToElement(selector) {
  if (document) {
    const element = document.querySelector(selector);

    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
        inline: 'nearest',
      });
    }
  }
}

export const useScrollToElement = selector => {
  return event => {
    event.preventDefault();
    scrollToElement(selector);
  };
};

const ScrollToElement = ({ selector, render }) =>
  render(scrollToElement.bind(null, selector));

export default ScrollToElement;
